// extracted by mini-css-extract-plugin
export default {"root":"index_root__4Uv29"};